import { useRoute } from 'react-router5';

export const useGetAuthorId = () => {
  const route = useRoute();

  return +route?.route.params.authorId;
};
